import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';
import axios from 'axios';
import Configdata from './Defaultdata';
import './home.css';
import Localdata from './Localdata';
import './cube.css';
import { arutyps,citiescodes,arrcomptype } from './userdefaultdata';
import Viewcompanies from './Viewcompanies'
export default class Company extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "siikaa";
	
  	}
	
    state = {

	
	cmptyeopt:0,
	citycode:'',

        name: "World",
        type: "1",
        Phone: null,
        msg: "",
        typeoption: null,
        respdata: null,
	companycode: '',
        isVisible: true,
        resm: null,
        url: "",
	cpmtp: [{ value: 3, label: 'Partner' }]
       	
       
    };

    
    utypeChange(event: any) {

        const typevalue = event.value;
       
        this.setState({ cmptyeopt: typevalue });
	
    }
    
	
    Homehitcount() {
              
        try {
          
            //const promiseAwait = fetch(Configdata.srvurl + '/Hitcountinput');
          }
        catch (e) {
            debugger;


        }
    }
  
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
        debugger;
     
        
        this.setserverurl();
	this.setState({ cpmtp: arrcomptype });
	
	

    }
    typeselect(e: any){
		
		
		const eid = e.target.id;
		e.target.style.backgroundColor = 'green';
		
		e.preventDefault()

     };
     viewcompanies(e: any){
		
		 try {
		
		const viewcompny = <Viewcompanies />
             
                var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		ReactDOM.render(viewcompny,maindiv);
		maindiv.style.display = 'block';
		Pdivr.style.display = 'none';
	   	}
	    	catch(e){
		
	        }	
	
	   	e.preventDefault()	
		
	};
     insertcompanies(e: any){
	 try {
          	const ctcod = this.state.citycode;
                var txtemil = document.getElementById('txtemailid') as HTMLInputElement;
		var txtphn = document.getElementById('txtphno') as HTMLInputElement;
		const emlid = txtemil.value;
		const uphn = txtphn.value;
            		

                const response = axios.post(Configdata.srvurl + '/insertcompany', {
    		uname: 'siikaa',
    		utypeid: 1,
    		uemail: emlid,
                uphone: uphn,
		citcod: ctcod
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const cmpcode = result.data;
		 this.setState({ companycode: cmpcode });

	        });		
              }
		

          }
        catch (e) {
            debugger;

        }

	
      	e.preventDefault()


     }	

    
 render() {

   
     return (

         <form>
	<div className="per100" id="postmain">
	 <div className="postingouterdiv" style={{overflowX:'hidden',overflowY:'auto',height:'93vh'}}>
	  <div className="postingtablediv">

	    <table className="postingtable">
		

		<tr>
		<td>
			<div className="postingrowdiv">
				<input type="text" placeholder="Enter Company name" id="txtownername" className="postingtxtbox" />
			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdropdown">
    <Select placeholder="Select type"  onChange={e => this.utypeChange(e) } id="utyp" options={this.state.cpmtp} className="postingtxtbox" />

			</div>
		</td>
		</tr>
		
		<tr>
		<td>
			<div className="postingrowdiv">
				<input type="text" placeholder="Enter Company Email" id="txtemailid" className="postingtxtbox" />
			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdiv">
				<input type="text" placeholder="Enter company Phone " id="txtphno" className="postingtxtbox" />
			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdiv">
				<input type="text" placeholder="Id proov Type" id="txthouseno" className="postingtxtbox" />
			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdiv">
				<input type="text" placeholder="Id proov No" id="txthouseno" className="postingtxtbox" />
			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdiv">
				 <a href="#" onClick={e => this.insertcompanies(e)} title="Partner">

					<div className="searchtype" id="btncompsubmit" style={{backgroundColor:'gray',marginLeft:'0px',float:'right'}}>
			  			Submit	
					</div>
				    </a>
				  <a href="#" onClick={e => this.viewcompanies(e)} title="Partner">

					<div className="searchtype" id="btncompview" style={{backgroundColor:'gray',marginLeft:'0px',float:'right'}}>
			  			View	
					</div>
				    </a>

				   
		     		

			</div>
			
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdiv">
				
					    {this.state.companycode}
			</div>
			
		</td>
		</tr>

	   </table>
	 </div>		
	</div>
	
	</div>
   	</form>
    
   
      );
}
}

